<div class="row">
  <div class="col-lg-12">
    @if (view !== 'collections') {
      <div class="mb-3">
        <button class="btn btn-sm btn-primary" type="button" (click)="onClickBack()"><i class="fa fa-chevron-left"></i> Back</button>
      </div>
    }
    <div class="card">
      <div class="card-header">
        @switch (view) {
          @case ('albums') { <i class="fa fa-book"></i> Albums - {{ selectedCollection?.name }} }
          @case ('cards') { <i class="fa fa-clone"></i> Cards - {{ selectedCollection?.name }} / {{ selectedAlbum?.name }} }
          @default { <i class="fa fa-folder"></i> Collections }
        }
      </div>
      <div class="card-body">
        @switch (view) {

          <!-- COLLECTIONS -->
          @case ('collections') {
            <table class="table table-responsive-sm table-hover table-outline align-middle mb-0">
              <thead class="thead-light">
                <tr>
                  <th>#</th>
                  <th>ID</th>
                  <th>Name</th>
                  <th>End Date</th>
                  <th>Cards</th>
                  <th>Unique Cards</th>
                  <th>Reward</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                @if (isLoading) {
                  <tr><td colspan="8" class="text-center"><span class="spinner-border spinner-border-sm"></span> Loading...</td></tr>
                } @else if (collections.length === 0) {
                  <tr><td colspan="8" class="text-center text-muted">No collection found.</td></tr>
                } @else {
                  @for (collection of collections; track collection.collectionId; let i = $index) {
                    <tr>
                      <td>{{ (pagination.pageNumber - 1) * resultsPerPage + i + 1 }}</td>
                      <td>{{ collection.collectionId }}</td>
                      <td>{{ collection.name }}</td>
                      <td>{{ collection.dateEnd > 0 ? dateService.getDateFromatted(collection.dateEnd) : '-' }}</td>
                      <td>{{ collection.cardsCount }}</td>
                      <td>{{ collection.cardsUniqueCount }}</td>
                      <td>
                        @if (collection.isRewardGranted) {
                          <span class="badge bg-success">Granted</span>
                        } @else {
                          <span class="badge bg-secondary">Not granted</span>
                        }
                      </td>
                      <td>
                        <button class="btn btn-sm btn-info" type="button" (click)="onClickCollectionDetails(collection)" tooltip="Details" placement="top"><i class="fa fa-eye"></i></button>
                      </td>
                    </tr>
                  }
                }
              </tbody>
            </table>
          }

          <!-- ALBUMS -->
          @case ('albums') {
            <table class="table table-responsive-sm table-hover table-outline align-middle mb-0">
              <thead class="thead-light">
                <tr>
                  <th>#</th>
                  <th>ID</th>
                  <th>Name</th>
                  <th>Cards</th>
                  <th>Unique Cards</th>
                  <th>Reward</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                @if (isLoading) {
                  <tr><td colspan="7" class="text-center"><span class="spinner-border spinner-border-sm"></span> Loading...</td></tr>
                } @else if (albums.length === 0) {
                  <tr><td colspan="7" class="text-center text-muted">No album found.</td></tr>
                } @else {
                  @for (album of albums; track album.albumId; let i = $index) {
                    <tr>
                      <td>{{ (pagination.pageNumber - 1) * resultsPerPage + i + 1 }}</td>
                      <td>{{ album.albumId }}</td>
                      <td>{{ album.name }}</td>
                      <td>{{ album.cardsCount }}</td>
                      <td>{{ album.cardsUniqueCount }}</td>
                      <td>
                        @if (album.isRewardGranted) {
                          <span class="badge bg-success">Granted</span>
                        } @else {
                          <span class="badge bg-secondary">Not granted</span>
                        }
                      </td>
                      <td>
                        <button class="btn btn-sm btn-info" type="button" (click)="onClickAlbumDetails(album)" tooltip="Details" placement="top"><i class="fa fa-eye"></i></button>
                      </td>
                    </tr>
                  }
                }
              </tbody>
            </table>
          }

          <!-- CARDS -->
          @case ('cards') {
            <table class="table table-responsive-sm table-hover table-outline align-middle mb-0">
              <thead class="thead-light">
                <tr>
                  <th>#</th>
                  <th>ID</th>
                  <th>Image</th>
                  <th>Name</th>
                  <th>Count</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                @if (isLoading) {
                  <tr><td colspan="6" class="text-center"><span class="spinner-border spinner-border-sm"></span> Loading...</td></tr>
                } @else if (cards.length === 0) {
                  <tr><td colspan="6" class="text-center text-muted">No card found.</td></tr>
                } @else {
                  @for (card of cards; track card.cardId; let i = $index) {
                    <tr>
                      <td>{{ (pagination.pageNumber - 1) * resultsPerPage + i + 1 }}</td>
                      <td>{{ card.cardId }}</td>
                      <td>
                        @if (hasImage(card)) {
                          <img [src]="getImageUrl(card)" (error)="onImageError(card)" alt="" style="max-height: 48px; max-width: 64px; object-fit: contain;">
                        } @else {
                          <span class="text-muted">-</span>
                        }
                      </td>
                      <td>{{ card.name }}</td>
                      <td>{{ card.cardsCount }}</td>
                      <td>
                        <button class="btn btn-sm btn-danger me-1" type="button" [disabled]="updatingCardId === card.cardId || card.cardsCount <= 0" (click)="onClickDecrementCard(card)" tooltip="Remove one" placement="top"><i class="fa fa-minus"></i></button>
                        <button class="btn btn-sm btn-success" type="button" [disabled]="updatingCardId === card.cardId" (click)="onClickIncrementCard(card)" tooltip="Add one" placement="top"><i class="fa fa-plus"></i></button>
                      </td>
                    </tr>
                  }
                }
              </tbody>
            </table>
          }
        }
        <br/>
        <div class="d-flex justify-content-between align-items-center">
          <small class="text-muted">
            Showing {{ (pagination.pageNumber - 1) * resultsPerPage + 1 }} to {{ (pagination.pageNumber - 1) * resultsPerPage + currentCount }} of {{ pagination.totalResults }} entries
          </small>
          <ul class="pagination pagination-sm mb-0">
            <li class="page-item" [class.disabled]="pagination.pageNumber <= 1">
              <button class="page-link" (click)="onClickPaginationPrevious()" [disabled]="pagination.pageNumber <= 1">&laquo;</button>
            </li>
            @for (page of getPageNumbers(); track $index) {
              @if (page === null) {
                <li class="page-item disabled"><span class="page-link">...</span></li>
              } @else {
                <li class="page-item" [class.active]="page === pagination.pageNumber">
                  <button class="page-link" (click)="goToPage(page)">{{ page }}</button>
                </li>
              }
            }
            <li class="page-item" [class.disabled]="pagination.pageNumber >= totalPages">
              <button class="page-link" (click)="onClickPaginationNext()" [disabled]="pagination.pageNumber >= totalPages">&raquo;</button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
